
import { defineComponent, computed, ref, nextTick } from "vue";
import { useStore } from "vuex";
import objectPath from "object-path";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "kt-account",
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const op = computed(() => objectPath);
    const tempImage = ref<string>("");
    const newImageAdded = ref<boolean>(false);
    let file: File;
    const saveChanges1 = async () => {
      try {
        let fd = new FormData();
        if (file) fd.append("profileImage", file, file.name);
        fd.append("firstName", user?.value?.firstName ?? "");
        fd.append("lastName", user?.value?.lastName ?? "");
        fd.append("linkedInProfileUrl", user?.value?.linkedInProfileUrl ?? "");
        fd.append("jobTitle", user?.value?.jobTitle ?? "");
        fd.append("telephone", user?.value?.telephone ?? "");
        fd.append("introduction", user?.value?.introduction ?? "");
        const response = await store.dispatch(Actions.UPDATE_PROFILE, fd);
        if (response !== true) throw new Error();
        store.dispatch(Actions.AUTH_USER);
        store.commit("setAlert", {
          message: "Profile Picture Updated",
          subMessage: "Profile Picture has been updated successfully",
          variant: "primary",
          duration: 4000,
          show: true,
        });
      } catch (err) {
        const error = store.getters.getErrors;
        store.commit("setAlert", {
          message: "Error",
          subMessage: error,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    const handleImageUpload = (event) => {
      file = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        tempImage.value = reader.result as string;
        newImageAdded.value = true;
      };
      nextTick(() => {
        saveChanges1();
      });
    };
    return {
      user,
      op,
      handleImageUpload,
    };
  },
});
